import { render, staticRenderFns } from "./ImportHistory.vue?vue&type=template&id=8a2ad95e&scoped=true&"
import script from "./ImportHistory.vue?vue&type=script&lang=js&"
export * from "./ImportHistory.vue?vue&type=script&lang=js&"
import style0 from "./ImportHistory.vue?vue&type=style&index=0&id=8a2ad95e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2ad95e",
  null
  
)

component.options.__file = "ImportHistory.vue"
export default component.exports